export default {
    name: 'employerprofileservice',
    dependencies: ['xhrservice'],
    callable(xhr) {
        function getRecommended() {
            return xhr.request({
                url: '/employer-profile/recommended.json',
                method: 'GET',
            });
        }

        function getRandom() {
            return xhr.request({
                url: '/employer-profile/random.json',
                method: 'GET',
            });
        }

        return {
            getRecommended,
            getRandom,
        };
    },
};



// WEBPACK FOOTER //
// ./services/employerprofileservice.js